import React from "react"
import { updateInternalSearchSessionStorage } from "components/page-components/Internal-Search/utils"

export const ChooseSingleTypeRefinementItem = ({
  count,
  type_name,
  text,
  is_deleted,
  set_focussed,
  searchState,
  setSearchState,
}) => {
  const handle_choice = () => {
    const updatedSearchState =
      type_name !== "notice"
        ? {
            ...searchState,
            refinementList: {
              ...searchState?.refinementList,
              type: [type_name],
            },
          }
        : {
            ...searchState,
            refinementList: { scope: ["notice"], type: [type_name] },
          }
    updateInternalSearchSessionStorage({
      last_search_state: updatedSearchState,
      focussed: true,
    })
    setSearchState(updatedSearchState)
    set_focussed(true)
  }
  return (
    <div
      onKeyPress={() => {}}
      role="button"
      tabIndex="-1"
      aria-label="choose refinement"
      onClick={handle_choice}
      className={`tag has-text-weight-bold internal-search-type-tag ${
        is_deleted ? "has-text-white is-refined" : "has-text-mitternachtsblau"
      } `}
    >
      <div
        className={`has-text-white has-text-centered has-background-mitternachtsblau internal-search-type-tag-cover`}
      >
        nur
      </div>
      {text} <span className="ml-2">({count})</span>
    </div>
  )
}
